import { render, staticRenderFns } from "./MemoryCircleTagManage.vue?vue&type=template&id=24fb7232&"
import script from "./MemoryCircleTagManage.vue?vue&type=script&lang=js&"
export * from "./MemoryCircleTagManage.vue?vue&type=script&lang=js&"
import style0 from "./MemoryCircleTagManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports